import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const CratioConfigModel = ({
  isOpen,
  headerTxt,
  toggleModal,
  component,
  okBtnCB,
  cancelBtnCB,
  okBtnTxt,
  cancelBtnTxt,
  footerComponent
}) => {
  return (
    <Modal
      backdrop={"static"}
      isOpen={isOpen}
      toggle={toggleModal}
      modalClassName={"config-modal"}
    >
      <ModalHeader toggle={toggleModal}>{headerTxt}</ModalHeader>
      <ModalBody>{component}</ModalBody>
      <ModalFooter>
      {footerComponent?<div className="custom-component">{footerComponent}</div>:<span></span>}
        <button
          type="button"
          onClick={(event) => {
            okBtnCB(event);
          }}
          className="le-button lePrimaryBtn"
        >
          {okBtnTxt}
        </button>
        <button
          type="button"
          onClick={(event) => {
            cancelBtnCB(event);
          }}
          className="le-button lePrimaryBtn"
        >
          {cancelBtnTxt}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CratioConfigModel;
